<template>
  <info-dialog
    v-model="modelValue"
    title="Interpretação da Espirometria"
  >
    <img src="/assets/attendance-form/spirometry-table.png" alt="" />
    <p class="font-size-12">Ref.: Protocolo Clínico e Diretrizes Terapêuticas - Asma (2021).</p>
  </info-dialog>
</template>

<script>
import { ComputedOptions } from 'vue'
import InfoDialog from '@/components/NewAttendanceForm/FormNodes/InfoDialogs/InfoDialog.vue'

export default {
  name: 'SpirometryDialog',
  components: { InfoDialog },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
